import { Add, CloseRounded } from "@mui/icons-material";
import {
  Autocomplete,
  Button,
  FormControl,
  FormLabel,
  IconButton,
  TextField,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useEffect } from "react";
import { useState } from "react";
import { createCourse } from "../../api";
import FormItem from "../ui/FormItem";
import Modal from "../ui/Modal";
import { useSnackbar } from "notistack";

const AddCourseModal = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const [course, setCourse] = useState(props.course);
  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setCourse({ ...course, [name]: value });
  };
  const [topics, setTopics] = useState({
    name: "",
    numClassesAssigned: 1,
    chapters: ["", ""],
  });
  const disabled = !course?.name || !course?.code;

  const handleSubmit = () => {
    //console.log(accountDetails);
    console.log(course);
    setLoading(true);
    createCourse(course)
      .then((res) => {
        enqueueSnackbar("Course added.", { variant: "success" });
        props.refresh();
        props.close();
      })
      .catch((err) => {
        enqueueSnackbar(err.data, { variant: "error" });
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => setCourse(props.course), [props.isOpen, props.course]);
  return (
    <Modal
      {...props}
      title={props.course ? "Edit Course" : "Add Course"}
      actionText="Save"
      loading={loading}
      action={handleSubmit}
    >
      <FormControl required fullWidth margin="dense">
        <FormLabel>Course name</FormLabel>
        <TextField name="name" value={course?.name} onChange={handleChange} />
      </FormControl>
      <FormControl required fullWidth margin="dense">
        <FormLabel>Course code</FormLabel>
        <TextField name="code" value={course?.code} onChange={handleChange} />
      </FormControl>

      <Stack>
        <FormControl fullWidth margin="dense">
          <FormLabel>Topic(s)</FormLabel>
        </FormControl>

        <Box sx={{ border: "2px dotted black", p: "8px" }} className="row">
          <Stack className="col" sx={{ width: "100%" }}>
            <Stack direction={"row"} spacing={2} alignItems="center">
              <FormItem label="Topic Name">
                <TextField />
              </FormItem>
              <FormItem label="No. of Classes">
                <TextField type="number" />
              </FormItem>
            </Stack>
            <FormItem label="Chapters" />

            {topics.chapters &&
              topics.chapters.map((courseId, index) => {
                return (
                  <>
                    <Stack
                      key={index}
                      direction={"row"}
                      spacing={2}
                      alignItems="center"
                      sx={{ my: "8px", width: "100%" }}
                    >
                      <Autocomplete
                        value={courseId}
                        sx={{ width: "100%" }}
                        onChange={(_, newValue) => {
                          // setFeeDetails({
                          //   ...feeDetails,
                          //   depositorId: newValue?.id,
                          // });
                        }}
                        // inputValue={inputValue}
                        // onInputChange={(_, newInputValue) => {
                        //   setInputValue(newInputValue);
                        //   searchStudents(newInputValue);
                        // }}
                        // getOptionLabel={(option) => option.label}
                        options={[]}
                        renderInput={(params) => (
                          <TextField sx={{ width: "100%" }} {...params} />
                        )}
                      />
                      <IconButton>
                        <CloseRounded sx={{ color: "red" }} />
                      </IconButton>
                    </Stack>
                  </>
                );
              })}
            <Box>
              <Button color="error" sx={{ ml: "10px" }} variant="outlined">
                {" "}
                Delete Topic{" "}
              </Button>
            </Box>
          </Stack>
        </Box>
        <Box className="row" sx={{ mt: "10px" }}>
          <Button variant="outlined">
            {" "}
            <Add /> Add Topic{" "}
          </Button>
        </Box>
      </Stack>
    </Modal>
  );
};

export default AddCourseModal;
